import { useTheme } from '../theme';
export const useLinkStyles = ({ themeName, color })=>{
    const theme = useTheme(themeName);
    return {
        link: {
            color: color ?? theme.text.link.default,
            textDecoration: 'underline',
            '&:hover, &:focus': {
                color: color ?? theme.text.link.hover
            }
        },
        button: {
            border: 'none',
            background: 'none',
            padding: 0
        }
    };
};

//# sourceMappingURL=link.styles.js.map